// TODO (Paul — Google Cloud Console):
//   1. HTTP referrer restriction: add localhost:* (dev) and *.sitescopeapp.com (prod)
//   2. Set a daily quota cap on the Maps JavaScript API to limit billing exposure
export const GMAP_KEY =
  process.env.REACT_APP_GMAP_KEY ||
  process.env.REACT_APP_GOOGLE_MAPS_KEY ||
  "";

// Generated from the canonical SQL classifier; never maintain a second list here.
// NULL is tolerated for historical rows by the SQL predicate, not stored in this array.
export { DA_FEED_APPLICATION_TYPES } from './daFeedApplicationTypes.generated.js';

// Rows hidden from the main dashboard feed and every customer-facing digest.
export const HIDDEN_STATUSES = new Set(['Withdrawn', 'Cancelled']);
export const ZONE_COLORS = [
  "#c0a060", // muted gold
  "#5580cc", // blue
  "#2a9d5a", // green
  "#e8504a", // red
  "#b060d0", // purple
  "#20b8a0", // teal
  "#e07830", // orange
  "#50a8e8", // sky blue
  "#d04888", // pink
  "#88b830", // lime
  "#40c0b0", // cyan
  "#e8c020", // yellow
  "#8858c8", // indigo
  "#e08840", // peach
  "#3898d0", // steel blue
  "#d86848", // terracotta
  "#58b868", // medium green
  "#c04878", // rose
  "#78a040", // olive green
  "#6070d8", // periwinkle
];

export const DEFAULT_ZONES = [
  { id: 1, name: "Byron Bay CBD", lat: -28.6434, lng: 153.6118, radius: 2000, color: "#c0a060" },
  { id: 2, name: "Bangalow",      lat: -28.6868, lng: 153.5315, radius: 3000, color: "#5580cc" },
  { id: 3, name: "Suffolk Park",  lat: -28.6780, lng: 153.6050, radius: 1500, color: "#2a9d5a" },
];

export const WATCH_ZONE_PRESETS = [
  // Byron Shire
  {name:"Bangalow",lat:-28.6868,lng:153.5315,council:"Byron Shire Council"},
  {name:"Billinudgel",lat:-28.4960,lng:153.5350,council:"Byron Shire Council"},
  {name:"Binna Burra",lat:-28.7100,lng:153.5100,council:"Byron Shire Council"},
  {name:"Broken Head",lat:-28.7050,lng:153.6150,council:"Byron Shire Council"},
  {name:"Brunswick Heads",lat:-28.5400,lng:153.5500,council:"Byron Shire Council"},
  {name:"Byron Bay",lat:-28.6434,lng:153.6118,council:"Byron Shire Council"},
  {name:"Coopers Shoot",lat:-28.6700,lng:153.5800,council:"Byron Shire Council"},
  {name:"Coorabell",lat:-28.6200,lng:153.4700,council:"Byron Shire Council"},
  {name:"Eureka",lat:-28.5800,lng:153.4200,council:"Byron Shire Council"},
  {name:"Ewingsdale",lat:-28.6300,lng:153.5600,council:"Byron Shire Council"},
  {name:"Federal",lat:-28.6500,lng:153.4600,council:"Byron Shire Council"},
  {name:"Goonengerry",lat:-28.5900,lng:153.4000,council:"Byron Shire Council"},
  {name:"Hayters Hill",lat:-28.6100,lng:153.5900,council:"Byron Shire Council"},
  {name:"Main Arm",lat:-28.5300,lng:153.4400,council:"Byron Shire Council"},
  {name:"McLeods Shoot",lat:-28.6500,lng:153.5800,council:"Byron Shire Council"},
  {name:"Montecollum",lat:-28.5400,lng:153.4600,council:"Byron Shire Council"},
  {name:"Mullumbimby",lat:-28.5540,lng:153.5010,council:"Byron Shire Council"},
  {name:"Mullumbimby Creek",lat:-28.5600,lng:153.4700,council:"Byron Shire Council"},
  {name:"Myocum",lat:-28.6000,lng:153.4900,council:"Byron Shire Council"},
  {name:"Nashua",lat:-28.6600,lng:153.4400,council:"Byron Shire Council"},
  {name:"New Brighton",lat:-28.5130,lng:153.5550,council:"Byron Shire Council"},
  {name:"Newrybar",lat:-28.7200,lng:153.5500,council:"Byron Shire Council"},
  {name:"Ocean Shores",lat:-28.5100,lng:153.5400,council:"Byron Shire Council"},
  {name:"Possum Creek",lat:-28.6400,lng:153.5200,council:"Byron Shire Council"},
  {name:"Skinners Shoot",lat:-28.6600,lng:153.6000,council:"Byron Shire Council"},
  {name:"South Golden Beach",lat:-28.5020,lng:153.5480,council:"Byron Shire Council"},
  {name:"Suffolk Park",lat:-28.6780,lng:153.6050,council:"Byron Shire Council"},
  {name:"Talofa",lat:-28.6900,lng:153.5700,council:"Byron Shire Council"},
  {name:"Tyagarah",lat:-28.5800,lng:153.5400,council:"Byron Shire Council"},
  {name:"Wilsons Creek",lat:-28.5700,lng:153.4500,council:"Byron Shire Council"},
  {name:"Wooyung",lat:-28.4700,lng:153.5300,council:"Byron Shire Council"},
  {name:"Yelgun",lat:-28.4800,lng:153.5200,council:"Byron Shire Council"},
  // Ballina Shire
  {name:"Alstonvale",lat:-28.8500,lng:153.4600,council:"Ballina Shire Council"},
  {name:"Alstonville",lat:-28.8420,lng:153.4400,council:"Ballina Shire Council"},
  {name:"Ballina",lat:-28.8670,lng:153.5660,council:"Ballina Shire Council"},
  {name:"Brooklet",lat:-28.7600,lng:153.5600,council:"Ballina Shire Council"},
  {name:"Cumbalum",lat:-28.8300,lng:153.5300,council:"Ballina Shire Council"},
  {name:"Dalwood",lat:-28.8400,lng:153.4000,council:"Ballina Shire Council"},
  {name:"East Ballina",lat:-28.8600,lng:153.5900,council:"Ballina Shire Council"},
  {name:"Empire Vale",lat:-28.9300,lng:153.5200,council:"Ballina Shire Council"},
  {name:"Fernleigh",lat:-28.8800,lng:153.4800,council:"Ballina Shire Council"},
  {name:"Keith Hall",lat:-28.9000,lng:153.5500,council:"Ballina Shire Council"},
  {name:"Knockrow",lat:-28.7500,lng:153.5400,council:"Ballina Shire Council"},
  {name:"Lennox Head",lat:-28.7870,lng:153.5900,council:"Ballina Shire Council"},
  {name:"McLeans Ridges",lat:-28.8100,lng:153.3800,council:"Ballina Shire Council"},
  {name:"Meerschaum Vale",lat:-28.9100,lng:153.4600,council:"Ballina Shire Council"},
  {name:"Newrybar",lat:-28.7300,lng:153.5500,council:"Ballina Shire Council"},
  {name:"North Ballina",lat:-28.8300,lng:153.5500,council:"Ballina Shire Council"},
  {name:"Patchs Beach",lat:-28.9600,lng:153.5000,council:"Ballina Shire Council"},
  {name:"Pimlico",lat:-28.9400,lng:153.4400,council:"Ballina Shire Council"},
  {name:"Rous",lat:-28.8900,lng:153.4200,council:"Ballina Shire Council"},
  {name:"Rous Mill",lat:-28.8800,lng:153.4000,council:"Ballina Shire Council"},
  {name:"Skennars Head",lat:-28.7950,lng:153.6000,council:"Ballina Shire Council"},
  {name:"South Ballina",lat:-28.9200,lng:153.5400,council:"Ballina Shire Council"},
  {name:"Teven",lat:-28.8100,lng:153.4800,council:"Ballina Shire Council"},
  {name:"Tintenbar",lat:-28.7800,lng:153.5200,council:"Ballina Shire Council"},
  {name:"Uralba",lat:-28.8700,lng:153.4900,council:"Ballina Shire Council"},
  {name:"Wardell",lat:-28.9500,lng:153.4600,council:"Ballina Shire Council"},
  {name:"West Ballina",lat:-28.8500,lng:153.5300,council:"Ballina Shire Council"},
  {name:"Wollongbar",lat:-28.8200,lng:153.4200,council:"Ballina Shire Council"},
  // Lismore City
  {name:"Bentley",lat:-28.7400,lng:153.2200,council:"Lismore City Council"},
  {name:"Bexhill",lat:-28.7600,lng:153.3500,council:"Lismore City Council"},
  {name:"Blakebrook",lat:-28.7700,lng:153.2800,council:"Lismore City Council"},
  {name:"Boat Harbour",lat:-28.7500,lng:153.2600,council:"Lismore City Council"},
  {name:"Caniaba",lat:-28.8600,lng:153.2400,council:"Lismore City Council"},
  {name:"Chilcotts Grass",lat:-28.8300,lng:153.3000,council:"Lismore City Council"},
  {name:"Clunes",lat:-28.7300,lng:153.4000,council:"Lismore City Council"},
  {name:"Coffee Camp",lat:-28.6500,lng:153.2600,council:"Lismore City Council"},
  {name:"Corndale",lat:-28.7400,lng:153.3600,council:"Lismore City Council"},
  {name:"Dorroughby",lat:-28.6800,lng:153.3800,council:"Lismore City Council"},
  {name:"Dunoon",lat:-28.6800,lng:153.3200,council:"Lismore City Council"},
  {name:"East Lismore",lat:-28.8050,lng:153.2950,council:"Lismore City Council"},
  {name:"Eltham",lat:-28.7600,lng:153.4200,council:"Lismore City Council"},
  {name:"Girards Hill",lat:-28.8100,lng:153.2800,council:"Lismore City Council"},
  {name:"Goolmangar",lat:-28.7300,lng:153.2800,council:"Lismore City Council"},
  {name:"Goonellabah",lat:-28.8200,lng:153.3100,council:"Lismore City Council"},
  {name:"Howards Grass",lat:-28.8400,lng:153.2300,council:"Lismore City Council"},
  {name:"Jiggi",lat:-28.7100,lng:153.2400,council:"Lismore City Council"},
  {name:"Koonorigan",lat:-28.7200,lng:153.3400,council:"Lismore City Council"},
  {name:"Lismore",lat:-28.8120,lng:153.2760,council:"Lismore City Council"},
  {name:"Lismore Heights",lat:-28.8000,lng:153.2600,council:"Lismore City Council"},
  {name:"Modanville",lat:-28.7200,lng:153.3100,council:"Lismore City Council"},
  {name:"Monaltrie",lat:-28.8400,lng:153.2600,council:"Lismore City Council"},
  {name:"Nimbin",lat:-28.5960,lng:153.2230,council:"Lismore City Council"},
  {name:"North Lismore",lat:-28.7900,lng:153.2700,council:"Lismore City Council"},
  {name:"Repentance Creek",lat:-28.7000,lng:153.3600,council:"Lismore City Council"},
  {name:"Richmond Hill",lat:-28.8400,lng:153.2900,council:"Lismore City Council"},
  {name:"Rosebank",lat:-28.7000,lng:153.3800,council:"Lismore City Council"},
  {name:"South Lismore",lat:-28.8300,lng:153.2700,council:"Lismore City Council"},
  {name:"The Channon",lat:-28.6800,lng:153.3400,council:"Lismore City Council"},
  {name:"Tregeagle",lat:-28.8300,lng:153.3300,council:"Lismore City Council"},
  {name:"Tucki Tucki",lat:-28.8800,lng:153.3500,council:"Lismore City Council"},
  {name:"Tullera",lat:-28.7500,lng:153.3000,council:"Lismore City Council"},
  {name:"Tuncester",lat:-28.7800,lng:153.2500,council:"Lismore City Council"},
  // Tweed Shire
  {name:"Banora Point",lat:-28.2200,lng:153.5300,council:"Tweed Shire Council"},
  {name:"Bilambil",lat:-28.2200,lng:153.4800,council:"Tweed Shire Council"},
  {name:"Bilambil Heights",lat:-28.2100,lng:153.4800,council:"Tweed Shire Council"},
  {name:"Bogangar",lat:-28.3200,lng:153.5700,council:"Tweed Shire Council"},
  {name:"Bray Park",lat:-28.3300,lng:153.4000,council:"Tweed Shire Council"},
  {name:"Burringbar",lat:-28.4300,lng:153.4700,council:"Tweed Shire Council"},
  {name:"Byangum",lat:-28.3400,lng:153.3600,council:"Tweed Shire Council"},
  {name:"Cabarita Beach",lat:-28.3330,lng:153.5730,council:"Tweed Shire Council"},
  {name:"Casuarina",lat:-28.2800,lng:153.5800,council:"Tweed Shire Council"},
  {name:"Chillingham",lat:-28.3200,lng:153.3000,council:"Tweed Shire Council"},
  {name:"Chinderah",lat:-28.2400,lng:153.5400,council:"Tweed Shire Council"},
  {name:"Clothiers Creek",lat:-28.3300,lng:153.5300,council:"Tweed Shire Council"},
  {name:"Cobaki",lat:-28.2100,lng:153.4500,council:"Tweed Shire Council"},
  {name:"Cobaki Lakes",lat:-28.2000,lng:153.4600,council:"Tweed Shire Council"},
  {name:"Condong",lat:-28.3100,lng:153.4200,council:"Tweed Shire Council"},
  {name:"Crabbes Creek",lat:-28.4500,lng:153.5100,council:"Tweed Shire Council"},
  {name:"Crystal Creek",lat:-28.3500,lng:153.3200,council:"Tweed Shire Council"},
  {name:"Cudgen",lat:-28.2700,lng:153.5500,council:"Tweed Shire Council"},
  {name:"Cudgera Creek",lat:-28.3700,lng:153.5500,council:"Tweed Shire Council"},
  {name:"Dulguigan",lat:-28.3000,lng:153.4500,council:"Tweed Shire Council"},
  {name:"Dunbible",lat:-28.3500,lng:153.3800,council:"Tweed Shire Council"},
  {name:"Duranbah",lat:-28.1700,lng:153.5600,council:"Tweed Shire Council"},
  {name:"Eungella",lat:-28.3700,lng:153.3500,council:"Tweed Shire Council"},
  {name:"Fingal Head",lat:-28.1950,lng:153.5650,council:"Tweed Shire Council"},
  {name:"Hastings Point",lat:-28.3600,lng:153.5750,council:"Tweed Shire Council"},
  {name:"Kings Forest",lat:-28.2900,lng:153.5500,council:"Tweed Shire Council"},
  {name:"Kingscliff",lat:-28.2590,lng:153.5760,council:"Tweed Shire Council"},
  {name:"Mooball",lat:-28.4400,lng:153.5000,council:"Tweed Shire Council"},
  {name:"Murwillumbah",lat:-28.3260,lng:153.3970,council:"Tweed Shire Council"},
  {name:"Nunderi",lat:-28.2700,lng:153.4400,council:"Tweed Shire Council"},
  {name:"Palmvale",lat:-28.2900,lng:153.4200,council:"Tweed Shire Council"},
  {name:"Pottsville",lat:-28.3880,lng:153.5640,council:"Tweed Shire Council"},
  {name:"Round Mountain",lat:-28.3600,lng:153.5400,council:"Tweed Shire Council"},
  {name:"Salt",lat:-28.2700,lng:153.5750,council:"Tweed Shire Council"},
  {name:"Sleepy Hollow",lat:-28.3500,lng:153.5200,council:"Tweed Shire Council"},
  {name:"South Murwillumbah",lat:-28.3400,lng:153.3900,council:"Tweed Shire Council"},
  {name:"Stokers Siding",lat:-28.4100,lng:153.4500,council:"Tweed Shire Council"},
  {name:"Stotts Creek",lat:-28.2500,lng:153.4700,council:"Tweed Shire Council"},
  {name:"Terranora",lat:-28.2300,lng:153.5000,council:"Tweed Shire Council"},
  {name:"Tumbulgum",lat:-28.2800,lng:153.4700,council:"Tweed Shire Council"},
  {name:"Tweed Heads",lat:-28.1760,lng:153.5410,council:"Tweed Shire Council"},
  {name:"Tweed Heads South",lat:-28.2000,lng:153.5300,council:"Tweed Shire Council"},
  {name:"Tweed Heads West",lat:-28.1800,lng:153.5100,council:"Tweed Shire Council"},
  {name:"Tyalgum",lat:-28.3700,lng:153.2800,council:"Tweed Shire Council"},
  {name:"Uki",lat:-28.4100,lng:153.3600,council:"Tweed Shire Council"},
];

export const PRICE_RANGE_DEFS = [
  { id: 'under-50k', label: 'Under $50K',  min: 0,       max: 50000    },
  { id: '50k-500k',  label: '$50K–$500K',  min: 50000,   max: 500000   },
  { id: '500k-1m',   label: '$500K–$1M',   min: 500000,  max: 1000000  },
  { id: '1m-2m',     label: '$1M–$2M',     min: 1000000, max: 2000000  },
  { id: '2m-plus',   label: '$2M+',        min: 2000000, max: Infinity },
];

export const MAP_CENTRES = {
  byron:   { lat: -28.6434, lng: 153.6118, zoom: 12 },
  ballina: { lat: -28.8670, lng: 153.5660, zoom: 12 },
  lismore: { lat: -28.8120, lng: 153.2760, zoom: 12 },
  tweed:   { lat: -28.3260, lng: 153.3970, zoom: 12 },
  all:     { lat: -28.55,   lng: 153.40,   zoom: 10 },
};

export const DARK_MAP_STYLES = [
  { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
  { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#0e1626" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#304a7d" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
];

export const LIGHT_MAP_STYLES = [
  { elementType: "geometry", stylers: [{ color: "#f0ebe3" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#4a4030" }] },
  { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#c8d8e8" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#d8d0c4" }] },
  { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#c8d8b8" }] },
];
